"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizesInPx = {
  // height will be measured with lineHeight and paddings
  large: {
    minWidth: 300
  },
  medium: {
    minWidth: 200
  },
  small: {
    minWidth: 100
  }
};
var paddingInPx = {
  large: [14, 16],
  medium: [14, 16],
  small: [6, 16]
};
var fonts = {
  large: 'h3',
  medium: 'button',
  small: 'caption'
};

var getColorsSpec = function getColorsSpec(palette, color, variant) {
  var colors = {
    background: palette[color].main,
    color: palette[color].contrastText,
    disabledColor: palette.common.white,
    disabledBackground: palette.grey[400],
    hover: palette[color].light,
    active: palette[color].dark
  };

  if (variant === 'text') {
    colors = _objectSpread({}, colors, {
      background: 'transparent',
      color: color !== 'default' ? palette[color].main : palette[color].contrastText,
      disabledColor: palette.grey[400],
      disabledBackground: 'transparent'
    });
  }

  return (0, _styledComponents.css)(["background-color:", ";color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}&.Mui-disabled{color:", ";background-color:", ";}"], colors.background, colors.color, colors.hover, colors.active, colors.disabledColor, colors.disabledBackground);
};

var buildStyles = function buildStyles(_ref) {
  var size = _ref.size,
      color = _ref.color,
      _ref$theme = _ref.theme,
      typography = _ref$theme.typography,
      palette = _ref$theme.palette;
  var sizes = sizesInPx[size];
  var font = typography[fonts[size]];
  var padding = paddingInPx[size].map(function (i) {
    return typography.pxToRem(i);
  }).join(' ');
  return (0, _styledComponents.css)(["border-radius:100px;border:0;min-width:", ";padding:", ";font-family:", ";font-size:", ";line-height:", ";font-weight:", ";text-transform:", ";letter-spacing:", ";&.MuiButton-containedPrimary{", "}&.MuiButton-containedSecondary{", "}&.MuiButton-text{", "}&.MuiButton-textPrimary{", "}&.MuiButton-textSecondary{", "}"], typography.pxToRem(sizes.minWidth), padding, font.fontFamily, font.fontSize, font.lineHeight, font.fontWeight, font.textTransform, font.letterSpacing, getColorsSpec(palette, 'primary', 'contained'), getColorsSpec(palette, 'secondary', 'contained'), getColorsSpec(palette, 'default', 'text'), getColorsSpec(palette, 'primary', 'text'), getColorsSpec(palette, 'secondary', 'text'));
};

var Button = /*#__PURE__*/(0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Button"
})(["", ""], buildStyles);
Button.defaultProps = {
  size: 'medium',
  color: 'secondary',
  variant: 'contained',
  disableElevation: true
};
var _default = Button;
exports["default"] = _default;